import dayjs from 'dayjs';

import type { SupportMessage } from './types';

export type MessageDayGroup = { day: string; label: string; messages: SupportMessage[] };

/** "Oct 26, 2026" — date separator label between message days (Figma 2327-706785). */
export function formatMessageDay(iso: string): string {
  return dayjs(iso).format('MMM D, YYYY');
}

/** "10:45 AM" — per-bubble timestamp. */
export function formatMessageTime(iso: string): string {
  return dayjs(iso).format('h:mm A');
}

/** Group a chronological message list into contiguous per-calendar-day buckets. */
export function groupMessagesByDay(messages: SupportMessage[]): MessageDayGroup[] {
  const groups: MessageDayGroup[] = [];
  for (const message of messages) {
    const day = dayjs(message.createdAt).format('YYYY-MM-DD');
    const last = groups[groups.length - 1];
    if (last && last.day === day) {
      last.messages.push(message);
    } else {
      groups.push({ day, label: formatMessageDay(message.createdAt), messages: [message] });
    }
  }
  return groups;
}
